// API基础路径
export const BASE_URL = import.meta.env.VITE_GENERAL_API_URL + '/api'

// 不同服务的API基础路径
export const API_ENDPOINTS = {
  // 通用API (webman)
  GENERAL: import.meta.env.VITE_GENERAL_API_URL || '',
  // API路由前缀（多处 api 模块使用）
  API: (import.meta.env.VITE_GENERAL_API_URL || '') + '/api',
}

// 存储键定义
export const STORAGE_KEYS = {
  APP_AUTH: {
    CUSTOMER: 'APP_AUTH_CUSTOMER',
    MERCHANT: 'APP_AUTH_MERCHANT',
    RIDER: 'APP_AUTH_RIDER',
    PLATFORM: 'APP_AUTH_PLATFORM'  // 添加平台端存储键
  },
  CODE_MANAGE: {
    USER: 'code_manage_user',
    RIDER: 'code_manage_rider',
    MERCHANT: 'code_manage_merchant'
  },
  BACKEND_CODE_MANAGE: 'backend_code_manage',
  BACKEND_UPDATE_STATUS: 'backend_update_status',
  SITE_SETTINGS: 'site_settings'
}

// APP类型配置
export const APP_TYPES = {
  CUSTOMER: {
    key: 'CUSTOMER',
    name: '顾客端',
    appKey: 'customer_app',
    color: 'primary',
    icon: 'User'
  },
  MERCHANT: {
    key: 'MERCHANT',
    name: '商家端',
    appKey: 'merchant_app',
    color: 'blue',
    icon: 'Shop'
  },
  RIDER: {
    key: 'RIDER',
    name: '骑手端',
    appKey: 'delivery_app',
    color: 'success',
    icon: 'Van'
  },
  PLATFORM: {
    key: 'PLATFORM',
    name: '平台端',
    appKey: 'admin_app',
    color: 'warning',
    icon: 'Monitor'
  }
}

// 授权状态
export const AUTH_STATUS = {
  BOUND: {
    key: 'bound',
    name: '已绑定',
    type: 'success'
  },
  UNBOUND: {
    key: 'unbound',
    name: '未绑定',
    type: 'warning'
  }
}

// 业务配置
export const BUSINESS_CONFIG = {
  // 序列号长度
  SERIAL_LENGTH: 6,
  // 序列号生成重试次数
  SERIAL_RETRY_TIMES: 10,
  // 数据备份间隔（小时）
  BACKUP_INTERVAL: 24,
  // 最大备份保留数量
  MAX_BACKUP_COUNT: 30,
  // 日志保留天数
  LOG_RETENTION_DAYS: 30
}

// 验证规则
export const VALIDATION_RULES = {
  DOMAIN: /^[a-zA-Z0-9][-a-zA-Z0-9.]*\.[a-zA-Z]{2,}$/,
  PLATFORM_UID: /^[A-Za-z0-9_-]{4,32}$/
}